import { Block } from '../block.js'
import { ForBlock } from '../logic/for-block.js'
import { TextBlock } from './text-block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Expression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'
import { IconBlock } from './icon-block.js'

@jsonClass('DraggableHandleBlock')
export class DraggableHandleBlock extends Block {
	constructor(init: Partial<DraggableHandleBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new this({
			children: [
				new IconBlock({
					textCode: new TextOrExpression_assumeExpression(
						'drag_indicator',
						'T',
					),
				}),
			],
		})
	}

	getPreviewDirection(): 'row' | 'column' {
		return this.parent?.getPreviewDirection() ?? 'row'
	}

	getEditorCategory(): string {
		return 'Others'
	}
}
